import script from "./index-ten.vue?vue&type=script&setup=true&lang=js"
export * from "./index-ten.vue?vue&type=script&setup=true&lang=js"

import "./index-ten.vue?vue&type=style&index=0&id=a2eabffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2eabffa"]])

export default __exports__